// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM
import { http } from '@/shared/https';
import Vue from 'vue';
import { AppConstants as _app } from "@/shared/app.constants";

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        parentComponent: true,
        controllerName: "InitiativeCall",
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        actions: {
            listAction: "/api/InitiativeCall/GetInitiativeCallDetail/",
            deleteAction: "/api/InitiativeCall",
            updateAction: "/api/InitiativeCall",
            createAction: "/api/InitiativeCall"
        },
        fields: {
            InitiativeCallId: {
                primaryKey: true,
            },
            InitiativeId: {
                title: "Initiative",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                event: true
            },
            Name: {
                title: "Name",
                required: true,
                type: "TextInput",
                languageManager: true,
                tableName: "InitiativeCall"
            },
            CallNumber: {
                title: "Call Number",
                required: true,
                type: "TextInput",
            },
            TypeId: {
                type: "Hidden"
                // title: "Type",
                // required: true,
                // type: "ComboBox",
                // autocomplete: true,
            },
            GrantTypeId: {
                title: "Grant Type",
                required: true,
                type: "ComboBox",
                autocomplete: true,
            },
            TemplateId: {
                required: true,
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Application Template"
            },
            ConceptNoteCallId: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Call for Concept Note"
            },
            ScoreCategoryIds: {
                type: "MultiSelect",
                chips: true,
                title: "Review Form Criteria"
            },
            Countries: {
                type: "MultiSelect",
                chips: true,
                title: "Country"
            },
            BudgetAmount: {
                title: "Budget Amount",
                type: "Number",
                required: true,
                currency: {
                    enabled: true,
                    precision: 2
                }
            },
            BudgetCurrencyId: {
                title: "Budget Currency",
                type: "ComboBox",
                readonly: true,
                autocomplete: true
            },
            BudgetInstruction: {
                title: "Budget Instruction",
                type: "TextArea",
                languageManager: true,
                tableName: "InitiativeCall",
                htmlEditor: true
            },
            BudgetFootnote: {
                title: "Budget Footnote",
                type: "TextInput",
                languageManager: true,
                readonly: true,
                tableName: "InitiativeCall",
                htmlEditor: true
            },
            IndirectCost: {
                title: "Indirect Cost (%)",
                type: "Number",
                currency: {
                    enabled: true,
                    precision: 2
                }
            },
            IsFixedIndirectCost: {
                title: "Fixed Indirect Cost %",
                list: false,
                type: "ComboBox",
                autocomplete: true,                
                defaultValue: 0
            },
            WorkFlowStatusId: {
                type: "ComboBox",
                required: true,
                autocomplete: true,
                title: "Status",
            },
            Comments: {
                type: "TextArea",
                counter: 100,
                title: "Comments"
            },
            InstructionUrl: {
                title: "Detailed instructions for applicants Url",
                type: "TextInput",
                languageManager: true,
                tableName: "InitiativeCall",
            },
            FaqUrl: {
                title: "FAQ Url",
                type: "TextInput",
                languageManager: true,
                tableName: "InitiativeCall",
            },
            DocumentStoreId: {
                type: "Hidden"
            },
            IsHold: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Hold for Correction",
                defaultValue: 0,
                event: true
            },
            Duration:
            {
                title: "Project Duration(in months)",
                type: "Number",
            },
            MinReview:
            {
                title: "Minimum number of technical reviews",
                type: "Number",
                required: true
            },
            FinancialReportBudgetType: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Financial Report Budget Type"
            },
            AllowFinReportIndirectCost: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Allow Indirect Cost in Financial Report"
            },
            AllowCustomIndicator: {
                list: false,
                type: "ComboBox",
                autocomplete: true,
                title: "Allow Custom Indicator"
            }
        }
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
            let query = new URLSearchParams(window.location.search);
            let menuId: string = query.get('mId');

            if (menuId == _app.menu.callforProposalForm.toString()) {
                payload.rootState.initiativeCallFormIndex.editedItem.TypeId = _app.callType.fullProposal;
            } else if (menuId == _app.menu.callforConceptNoteForm.toString()) {
                payload.rootState.initiativeCallFormIndex.editedItem.TypeId = _app.callType.conceptNote;
            }

            let initiativeId = state.data.find(x => x)?.InitiativeId;
            let conceptNoteCallId = state.data.find(x => x)?.ConceptNoteCallId;

            return http.get(`/api/Initiative/${initiativeId}/Detail`).then(resp => {
                if (resp.status >= 200 && resp.status < 300) {
                    payload.rootState.initiativeCallFormIndex.fields.filter(x => x.value == 'ConceptNoteCallId').find(x => x).dropdown = resp.data.ConceptNoteCallId;

                    payload.rootState.initiativeCallFormIndex.showInputs = false;
                    Vue.nextTick(() => {
                        payload.rootState.initiativeCallFormIndex.showInputs = true;
                    });
                }
            });

        },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { },

        //#. workFlowStatusIdChange function
        workFlowStatusIdChange(state, context) {
            state.fields.filter(x => x.value == "WorkFlowStage").find(x => x).readonly = false;
            let displayName = context.payload.DisplayText;
            state.editedItem.WorkFlowStage = displayName;
            state.fields.filter(x => x.value == "WorkFlowStage").find(x => x).readonly = true;
        },

        initiativeIdChange(state, context) {
            return http.get(`/api/Initiative/${context.payload.Value}/Detail`).then(resp => {
                if (resp.status >= 200 && resp.status < 300) {
                    context.rootState.initiativeCallFormIndex.editedItem.ConceptNoteCallId = "";
                    context.rootState.initiativeCallFormIndex.fields.filter(x => x.value == 'ConceptNoteCallId').find(x => x).dropdown = resp.data.ConceptNoteCallId;

                    if (resp.data.Initiative.BudgetCurrencyId) {
                        let obj = context.rootState.initiativeCallFormIndex.fields.filter(x => x.value == 'BudgetCurrencyId').find(x => x).dropdown;
                        let text = obj.filter(x => x.Value == resp.data.Initiative.BudgetCurrencyId).find(x => x).DisplayText;
                        context.rootState.initiativeCallFormIndex.defaultItem.BudgetCurrencyId = { DisplayText: text, Value: resp.data.Initiative.BudgetCurrencyId }
                        context.rootState.initiativeCallFormIndex.editedItem.BudgetCurrencyId = { DisplayText: text, Value: resp.data.Initiative.BudgetCurrencyId }

                        context.rootState.initiativeCallFormIndex.showInputs = false;
                        Vue.nextTick(() => {
                            context.rootState.initiativeCallFormIndex.showInputs = true;
                        });
                        //context.rootState.initiativeCallFormIndex.fields.filter(x=> x.value == 'BudgetCurrencyId').find(x=> x).autocomplete = true;
                        //context.rootState.initiativeCallFormIndex.fields.filter(x=> x.value == 'BudgetCurrencyId').find(x=> x).select = { DisplayText: context.payload.DisplayText, Value: context.payload.Value };
                    }
                }
            });

            // For Future Reference
            // moduleGroupIdChange(state, context) {
            //     let payload = this.getters['userPermissionsIndex/getState'];

            //     payload.editedItem.ModuleId = "";
            //     let prop = context.rootState.userPermissionsIndex.fields.filter(x => x.value == 'ModuleId').find(x => x);

            //     if (prop.dependsOn == undefined) prop.dependsOn = prop.dropdown
            //     let moduleGroupId = context.payload.Value;

            //     if (moduleGroupId) {
            //         let relatedDDL = prop.dependsOn.filter(x => x.RelatedId == moduleGroupId);
            //         prop.dropdown = relatedDDL;

            //         let selectedItemId = context.rootState.userPermissionsIndex.fields.filter(x => x.value == 'ModuleId').find(x => x).dropdown.find(x => x).Value;
            //         let selectedItem = context.rootState.userPermissionsIndex.fields.filter(x => x.value == 'ModuleId').find(x => x).dropdown.find(x => x).DisplayText;
            //         payload.editedItem.ModuleId = selectedItem;
            //         payload.editedItem["ModuleId"] = { DisplayText: selectedItem, Value: selectedItemId };
            //     }
            // },
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        workFlowStatusIdChange: ({ commit, rootState }, payload) => {
            commit('workFlowStatusIdChange', { rootState, payload });
        },

        initiativeIdChange: ({ commit, rootState }, payload) => {
            commit('initiativeIdChange', { rootState, payload });
        },

        isHoldChange: ({ commit, rootState }, payload) => {
            if (payload.Value === 1) {
                rootState.initiativeCallFormIndex.buttonDisabled = true;

                return http.get(`/api/InitiativeCall/CanHold/${rootState.initiativeCallFormIndex.data[0].InitiativeCallId}`).then(resp => {
                    rootState.initiativeCallFormIndex.buttonDisabled = false;

                    if (resp.status >= 200 && resp.status < 300) {
                        if (resp.data.CanUpdate == false)
                            rootState.initiativeCallFormIndex.isInUse = true;
                        else
                            rootState.initiativeCallFormIndex.isInUse = false;
                    }
                });
            } else {
                rootState.initiativeCallFormIndex.buttonDisabled = false;
            }
        },

        //#. recordAdded event will be fired
        beforeUpdated: ({ commit, rootState }, payload) => {
        },
    }
}
